import React from 'react';
import styled, { css } from 'styled-components';

import { useMedia } from '@tager/web-core';

import { ContentContainer } from '@/modules/SinglePostDealerWeb/common.styles';
import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import { media } from '@/utils/mixin';
import { colors } from '@/constants/theme';

import PostsList from './components/PostsList';
import PostsSlider from './components/PostsSlider';

function MorePosts() {
  const page = useTypedSelector(selectSinglePost);
  const isMobile = useMedia('(max-width: 767px)');

  if (!page) {
    return null;
  }

  return (
    <Component>
      <ContentContainer>
        <Title>С этим читали</Title>
        {!isMobile ? <PostsList /> : <PostsSlider />}
      </ContentContainer>
    </Component>
  );
}

export default MorePosts;

const Component = styled.section`
  padding: 30px 0 60px;

  ${media.tablet(css`
    padding: 20px 0 40px;
  `)}
`;

const Title = styled.p`
  font-weight: 700;
  font-size: 25px;
  line-height: 32px;
  color: ${colors.black};

  ${media.tablet(css`
    font-size: 16px;
    line-height: 21px;
  `)}
`;
